import { useMemo } from 'react';

import { LeadMessagePhone } from '@app/components/LeadCard/ui/MessageHistory/components/LeadMessageText/ui/LeadMessagePhone';
import { parseLeadMessageParts } from '@app/components/LeadCard/ui/MessageHistory/lib';
import { selectCountries, useAppSelector } from '@app/store';
import { generateKey } from '@app/utils';

import type { FC } from 'react';

interface LeadMessageTextProps {
  message: string;
  socialType: string | null;
}

/**
 * Текст сообщения React-узлами: жирные фрагменты WhatsApp и кликабельные
 * номера телефонов. Экранирование делает сам React, поэтому innerHTML и
 * DOMPurify для тела сообщения больше не нужны.
 */
export const LeadMessageText: FC<LeadMessageTextProps> = ({
  message,
  socialType,
}) => {
  const countries = useAppSelector(selectCountries);

  const parts = useMemo(
    () => parseLeadMessageParts(message, socialType, countries),
    [message, socialType, countries]
  );

  return (
    <>
      {parts.map((part, index) => {
        const key = generateKey('LeadMessageText', part.kind, String(index));

        if (part.kind === 'phone') {
          return (
            <LeadMessagePhone
              key={key}
              value={part.value}
              digits={part.digits}
              countryId={part.countryId}
            />
          );
        }

        if (part.isBold) {
          return <b key={key}>{part.value}</b>;
        }

        return <span key={key}>{part.value}</span>;
      })}
    </>
  );
};
